import { PurchaseEvent } from '@/usecases/event-bus-for-third-party/event'

/**
 * GP独自フォーマットの注文完了イベント
 *
 * もともと注文完了時のイベントとして実装されていたが、
 * 後にGA4準拠のフォーマットで注文完了イベント (purchase) が実装されたため、
 * GA4への連携にはこのイベントは適していない。
 * 一方で、このイベントは既存でGoogle Analyticsへの連携以外にも
 * 広告成果計測などで利用されていたため、継続して利用されることになった。
 *
 * 2025/11時点で広告成果測定のためGTMに送信されているほか、
 * 接客ツールでも同じフォーマットを利用している
 *
 * 'e-commerce'では注文完了のイベントであることを想像できないので
 * イベント名は要議論ではある（運用上不都合はないので放置することにした）
 */
export interface GpEcommerceEvent {
  event: 'e-commerce'
  transactionId: string
  transactionTotal: number
  transactionTax: number
  transactionProducts: Array<{
    sku: string
    name: string
    price: number
    quantity: number
  }>
}

function createFromEventBusPurchaseEvent(event: PurchaseEvent): GpEcommerceEvent[] {
  const { orderResultSuccessList } = event

  return orderResultSuccessList.map((result) => {
    const subtotal = result.commerceSalesOrder.subtotalPrice
    const tax = result.commerceSalesOrder.tax
    const products = result.order.cartItems.map(cartItem => ({
      sku: cartItem.skuId,
      name: cartItem.name,
      price: cartItem.unitPrice,
      quantity: cartItem.unitCount,
    }))

    return {
      event: 'e-commerce',
      transactionId: result.commerceSalesOrder.compressedShortId,
      transactionTotal: subtotal,
      transactionTax: tax,
      transactionProducts: products,
      email: event.user.email,
      phone: event.user.tel,
    }
  })
}

export const gpEcommerceEventFactory = {
  createFromEventBusPurchaseEvent,
} as const
